import React from 'react';
import './css/main.css';

export const CPie = () => {
    return (
        <div> 
        </div>
    )
}
